/**
 * Branding Configuration
 * This file contains all branding-related configuration options
 * to make rebranding easier without changing multiple files.
 */

interface BrandingConfig {
  // Application name - shown in title, headers, etc.
  appName: string;
  
  // Short name - used in compact spaces
  shortName: string;
  
  // Company name - used in copyright, team names, etc.
  companyName: string;
  
  // Brand description/tagline
  tagline: string;
  
  // Website URL for the brand
  websiteUrl: string;
  
  // Support/wiki page URL
  supportUrl: string;
  
  // Support/wiki page title
  supportTitle: string;
  
  // Required email domain for authentication
  requiredEmailDomain: string;
  
  // Brand color theme (optional)
  colorTheme?: {
    primary: string;
    secondary: string;
    accent: string;
  };
}

// Default branding configuration - can be easily changed to rebrand
export const brandingConfig: BrandingConfig = {
  appName: "AKA Vault",
  shortName: "AKA",
  companyName: "AKA Virtual",
  tagline: "Secure Asset Management",
  websiteUrl: "https://akavirtual.com",
  supportUrl: "https://wiki.akavirtual.com/",
  supportTitle: "AKA Wiki",
  requiredEmailDomain: "@akavirtual.com",
  colorTheme: {
    primary: "#2563eb",
    secondary: "#1e40af",
    accent: "#3b82f6",
  }
};

// Function to override branding config at runtime if needed
export const updateBrandingConfig = (overrides: Partial<BrandingConfig>) => {
  Object.assign(brandingConfig, overrides);
};